export default __webpack_public_path__ + "static/outlook-hero-1-35bf7e67777bfb53ce51865faaedccb2.webp";